import { reaction } from 'mobx'
import { DEFAULT_META_TAGS } from '@/constants/seo.js'
import { truncate } from 'lodash-es'

export default class SeoStore {
  rootStore = null

  #descriptionTag = null
  #keywordsTag = null
  #imageTag = null
  #titleTag = null
  #urlTag = null
  #reactions = []

  constructor(rootStore) {
    this.rootStore = rootStore
    this.rootStore.registerAfterConstructor(this.#_afterConstructor)
    this.rootStore.registerDeconstructor(this.#_deconstructor)

    this.#descriptionTag = document.querySelector('meta[name="description"]')
    this.#keywordsTag = document.querySelector('meta[name="keywords"]')
    this.#imageTag = document.querySelector('meta[property="og:image"]')
    this.#titleTag = document.querySelector('meta[property="og:title"]')
    this.#urlTag = document.querySelector('meta[property="og:url"]')
  }

  #_afterConstructor = () => {
    this.#reactions.push(reaction(() => this.router.url, this.#onUrlChanged))
  }

  #_deconstructor = () => {
    this.#reactions.forEach(x => x())
    this.#reactions = []
  }

  get app() {
    return this.rootStore.appStore
  }

  get router() {
    return this.rootStore.routerStore
  }

  update = ({
    description = DEFAULT_META_TAGS.description,
    image = DEFAULT_META_TAGS.image,
    keywords = [],
    title = '',
  }) => {
    this.#descriptionTag.setAttribute(
      'content',
      truncate(description ?? DEFAULT_META_TAGS.description, {
        length: DEFAULT_META_TAGS.descriptionMaxLength,
      })
    )
    this.#imageTag.setAttribute('content', image ?? DEFAULT_META_TAGS.image)

    keywords.push(DEFAULT_META_TAGS.keywords)
    this.#keywordsTag.setAttribute('content', keywords.join(', '))

    const finalTitle = title
      ? `${truncate(title, { length: DEFAULT_META_TAGS.titleMaxLength - DEFAULT_META_TAGS.titleSuffixLength })} - ${import.meta.env.VITE_APP_NAME}`
      : DEFAULT_META_TAGS.title
    document.title = this.app.isStandalone ? import.meta.env.VITE_APP_NAME : finalTitle
    this.#titleTag.setAttribute('content', title || finalTitle)

    this.#urlTag.setAttribute('content', this.router.url)
  }

  reset = () => {
    this.update({})
  }

  #onUrlChanged = () => {
    this.update(this.router.routeData.seo ?? {})
  }
}
